// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__x_bdm","container":"styles_container__3O6uD","title":"styles_title__3Enw9","wrapper":"styles_wrapper__UbJgW","answer":"styles_answer__3RAbU"};